/**
 * AI usage tracking API
 */

import { fetchApi } from './fetch';

export interface UsageSummary {
  totalCostUsd: number;
  totalInputTokens: number;
  totalOutputTokens: number;
  byModel: Array<{
    model: string;
    costUsd: number;
    inputTokens: number;
    outputTokens: number;
    callCount: number;
  }>;
  period: string;
}

export async function getUsageSummary(period: 'month' | 'week' = 'month'): Promise<UsageSummary> {
  return fetchApi<UsageSummary>(`/usage/summary?period=${period}`);
}
